import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { StickyBanner } from '../../index';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "sticky-banner"
    }}>{`Sticky Banner`}</h1>
    <p>{`A display banner that can be made to "stick" in a specific position on a desktop screen, 9 positions are available.
The sticky banner comes in various sizes: 160x600, 300x250, 728x90 and 900x250.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<StickyBanner\n  zoneId=\"4294580\"\n  horizontalPosition=\"right\"\n  verticalPosition=\"middle\"\n  format=\"160x600\"\n/>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      StickyBanner,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <StickyBanner zoneId="4294580" horizontalPosition="right" verticalPosition="middle" format="160x600" mdxType="StickyBanner" />
    </Playground>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={StickyBanner} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      